import * as Sentry from '@sentry/react'
import { AxiosResponse } from 'axios'

export const reportErrorToSentry = (
    response: AxiosResponse<unknown, unknown>
) => {
    const requestConfig = response?.config
    const errorData = response?.data as {
        detail?: string
        message?: string
        error_key?: string
    }
    const urlSplit = requestConfig?.url?.split('?')
    if (Array.isArray(urlSplit)) {
        if (urlSplit.length > 1) {
            const queryParams = requestConfig?.url?.slice(
                requestConfig?.url?.indexOf('?') + 1
            )
            Sentry.setExtra('query_params', queryParams)
        }
        Sentry.setExtra('request_body', requestConfig?.data)
        Sentry.setExtra('error_detail', errorData?.detail)
        Sentry.setExtra('error_message', errorData?.message)
        Sentry.setExtra('error_key', errorData?.error_key)
        Sentry.captureMessage(
            `${requestConfig?.method?.toUpperCase()} (${response.status}): ${
                urlSplit[0]
            }`
        )
    }
}
